<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="系统模块">
              <a-input placeholder="请输入" v-model="queryParams.title"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="操作人员">
              <a-input placeholder="请输入" v-model="queryParams.operName"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="类型">
              <a-select button-style="solid" v-model="queryParams.businessType">
                <a-select-option
                  v-for="dict in typeOptions"
                  :key="dict.dictValue"
                  :value="dict.dictValue">
                  {{ dict.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="状态">
              <a-select button-style="solid" v-model="queryParams.status">
                <a-select-option
                  v-for="dict in statusOptions"
                  :key="dict.dictValue"
                  :value="dict.dictValue">
                  {{ dict.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="7" :sm="24" v-if="advanced">
            <a-form-item label="操作时间">
              <!--  @change="onChange" -->
              <a-range-picker @change="rangePicker" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="handleExport()" type="primary" v-hasPermi="['system:operlog:export']">导出</a-button>
      <a-button @click="handleDeleteBatch(selectedRowKeys)" :disabled="selectedRowKeys.length === 0" v-hasPermi="['system:operlog:remove']">删除</a-button>
      <a-button @click="handleClean()" v-hasPermi="['system:operlog:remove']">清空日志</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- <a-card :bordered="false" class="content"> -->

        <!-- 表格 -->
        <!-- <a-table
          ref="table"
          :columns="columns"
          :loading="tableLoading"
          :data-source="list"
          :row-selection="rowSelection"
          row-key="operId"
          :pagination="false"
        >
          <span slot="businessType" slot-scope="text, record">
            {{ typeFormat(record) }}
          </span>
          <span slot="status" slot-scope="text, record">
            {{ statusFormat(record) }}
          </span>

          <span slot="action" slot-scope="text, record">
            <a @click="$refs.detailDrawer.show(record)" v-hasPermi="['system:operlog:query']">详细</a>
          </span>
        </a-table> -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          rowKey="operId"
          :scroll="{ fixScreen: true, x: 1300 }"
          @selectedRowChange="selectedRowChange"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.OPERATION_LOG_LIST, // 表格方案配置唯一值
              }"
        >
          <span slot="businessType" slot-scope="{ record }">
            {{ typeFormat(record) }}
          </span>
          <span slot="status" slot-scope="{ record }">
            {{ statusFormat(record) }}
          </span>

          <span slot="action" slot-scope="{ record }">
            <a @click="$refs.detailDrawer.show(record)">详细</a>
          </span>
        </ls-api-table>
        <!-- 底部分页按钮 -->
        <!-- 详细 -->
        <detail-drawer ref="detailDrawer" />
        <!-- </a-card> -->
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { cleanOperlog, delOperlog, list } from '@/api/system/operlog'
import DetailDrawer from './components/DetailDrawer'
import { generateLsTableResData } from '@/utils/util.js';

export default {
  components: { DetailDrawer },
  name: 'Operlog',
  data () {
    return {
       // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(list, true),
        pageCurrent: true
      },
      // 高级搜索 展开/关闭
      advanced: true,
      // 分页数据(默认第一页):
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      current: 1,
      pageSize: 10,
      total: 0,
      // 表格数据
      list: [],
      // 类型数据字典
      typeOptions: [],
      // 类型数据字典
      statusOptions: [],
      // 表格等待
      tableLoading: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        title: undefined,
        operName: undefined,
        businessType: undefined,
        status: undefined
      },
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      },
      // 日期范围
      dateRange: [],
      // 表格属性
      columns: [
        {
          title: '日志编号',
          // width: 120,
          dataIndex: 'operId',
          align: 'center'
        },
        {
          title: '系统模块',
          dataIndex: 'title',
          ellipsis: true,
          // width: 120,
          align: 'center'
        },
        {
          title: '操作类型',
          // width: 120,
          dataIndex: 'businessType',
          align: 'center'
        },
        {
          title: '请求方式',
          // width: 120,
          dataIndex: 'requestMethod',
          scopedSlots: { customRender: 'requestMethod' },
          align: 'center'
        },
        {
          title: '操作人员',
          // width: 120,
          dataIndex: 'operName',
          align: 'center'
        },
        {
          title: '主机',
          // width: 120,
          dataIndex: 'operIp',
          align: 'center'
        },
        {
          title: '操作状态',
          // width: 120,
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: '操作日期',
          // width: 180,
          dataIndex: 'operTime',
          scopedSlots: { customRender: 'operTime' },
          align: 'center'
        },
        {
          title: '操作',
          width: 150,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created () {
    // this.getList()
    this.getDicts('sys_oper_type').then(response => {
      this.typeOptions = response.data
    })
    this.getDicts('sys_common_status').then(response => {
      this.statusOptions = response.data
    })
  },
  mounted () {
    this.onSearch();
  },
  methods: {
     // 表单搜索
    onSearch () {
      this.$refs.dataTable.searchParams = this.addDateRange(this.queryParams, this.dateRange);
      this.$refs.dataTable.getData();
    },
     /** 行选中 */
     selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    /** 查询登录日志 */
    getList () {
      this.tableLoading = true
      list(this.addDateRange(this.queryParams, this.dateRange)).then(response => {
          this.list = response.rows
          this.total = response.total
          this.tableLoading = false
        }
      )
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 操作日志状态字典翻译
    statusFormat (row, column) {
      return this.selectDictLabel(this.statusOptions, row.status)
    },
    // 操作日志类型字典翻译
    typeFormat (row, column) {
      return this.selectDictLabel(this.typeOptions, row.businessType)
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParams.pageNum = 1
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.dateRange = []
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        title: undefined,
        operName: undefined,
        businessType: undefined,
        status: undefined
      }
      this.handleQuery()
    },
    // 搜索框中的日期选择
    rangePicker (date, dateString) {
      this.dateRange = dateString
    },
    /** 批量删除按钮操作 */
    handleDeleteBatch (ids) {
      const operIds = ids
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除 操作日志编号为${operIds}的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          delOperlog(operIds).then(response => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    /** 清空按钮操作 */
    handleClean () {
      const self = this
      this.$confirm({
        title: '警告',
        content: `是否确认清空所有操作日志数据项?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          cleanOperlog().then(response => {
            if (response.code === 200) {
              self.$message.success('清空成功!')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      this.download('system/operlog/export', {
        ...this.queryParams
      }, `operlog_${new Date().getTime()}.xlsx`)
    }
  }
}
</script>
